import { Box, styled, Typography, IconButton } from '@mui/material'

export const Wrapper = styled(Box)`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 358px;
  background: ${({ theme }) => theme.palette.custom.white};
  overflow: hidden;
`

export const Header = styled(Box)`
  height: 64px;
  padding: 0 24px;
  border-bottom: 1px solid #dde1e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.custom.gray11};
  font-size: 19px;
  font-weight: 500;
  text-transform: uppercase;
`

export const FilterWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`

export const DivisionRow = styled(Box)`
  display: flex;
  height: 54px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.custom.gray12};
`

export const SearchRow = styled(Box)`
  display: flex;
  height: 54px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.custom.gray12};
`

export const SearchInputWrapper = styled(Box)`
  flex: 1;
  display: flex;
  align-items: center;
  padding: 0 16px;
`

export const DivisionSelectorWrapper = styled(Box)`
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 16px;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.palette.custom.gray4};
  }
`

export const DivisionName = styled(Typography)`
  flex: 1;
  font-size: 16px;
  font-weight: 500;
  color: #4c5783;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const SearchIconWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  color: ${({ theme }) => theme.palette.custom.gray15};

  & svg {
    width: 16px;
    height: 16px;
  }
`

export const ProductList = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

export const ProductItem = styled(Box)`
  height: 88px;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.palette.custom.gray12};
  background: ${({ theme }) => theme.palette.custom.white};

  &:hover {
    background: ${({ theme }) => theme.palette.custom.gray4};
  }

  &:last-child {
    border-bottom: none;
  }
`

export const LoaderWrapper = styled(Box)`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const PlaceholderWrapper = styled(Box)`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StyledIconButton = styled(IconButton)`
  width: 26px;
  height: 26px;
`
